import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types';
import renderIf from 'render-if';
import Input from 'react-toolbox/lib/input';// to use input from react-toolbox library
import Button from 'components/CustomButton';
import SearchCollegeComponent from 'components/CoachRegistration';
import AutocompleteToolbox from 'react-toolbox/lib/autocomplete';
import { regExForName, regExForEmail } from 'constants/Regularexpression';
import { states as statesList } from 'constants/DropdownsValues';
import Error from 'components/ErrorMessage';
// import UserInfo from '../../../Userinfo/index';
import styles from './styles.scss';

// to import local scss fle

class DeleteCoach extends Component {
  static propTypes = {
    addCoach: PropTypes.func.isRequired,
    coachAdded: PropTypes.func.isRequired,
    resetValues: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      fullName: '',
      fullNameErrorMessage: '',
      college: '',
      state: '',
      city: '',
      sport: 'FOOTBALL',
      validHighSchool: false,
      highSchoolErrorMessage: '',
      validState: false,
      stateErrorMessage: '',
      validCity: false,
      cityErrorMessage: '',
      validTeamPageUrl: false,
      teamPageUrlErrorMessage: '',
      validQuestionaire: false,
      questionaireErrorMessage: '',
      email: '',
      emailErrorMessage: '',
      addAnotherCoach: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.coachAdded) {
      this.setState({ addAnotherCoach: false });
    }
  }
  getDataForCoach = (value) => {
    const newState = {
      city: value.city,
      division: value.division,
      questionLink: value.questionLink,
      state: value.state,
      teamPageUrl: value.teamPageUrl,
      college: value.value,
      college_id: value.id,
    };
    this.setState(newState);
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  removeValue = (name) => {
    this.setState({ ...this.state, [name]: '' });
  };

  addAnotherCoach = () => {
    this.setState({
      addAnotherCoach: true,
      city: '',
      state: '',
      fullName: '',
      email: '',
      collegeId: '',
      teamPageUrl: '',
      questionLink: '',
    });
    this.props.resetValues('RESET_ADD_COACH');
  };

  handleOnclick = () => {
    /* validations for field */
    const enteredValue = this.state.college;
    const highSchool = typeof enteredValue === 'string';
    const updated = {};
    if (highSchool && this.state.college !== '') {
      updated.validHighSchool = true;
    } else {
      updated.highSchoolErrorMessage = 'PLease insert a valid school name';
    }
    /* validations for field */

    /* validation for state */
    if (this.state.state === '') {
      updated.stateErrorMessage = 'Please select state.';
    } else {
      updated.validState = true;
    }
    /* validation for state */

    /* validation of city */
    const selectedCity = regExForName.test(this.state.city);
    if (selectedCity && this.state.city !== '') {
      updated.validCity = true;
    } else {
      updated.cityErrorMessage = 'City is not added.';
    }
    /* validation of city */

    /* validation of fullname */
    const fullnameAdded = regExForName.test(this.state.fullName);
    if (fullnameAdded && this.state.fullName !== '') {
      updated.validCity = true;
    } else {
      updated.fullNameErrorMessage = 'Add a valid name';
    }
    /* validation of fullname */

    /* validation of fullname */
    let validEmail = false;
    const emailAdded = regExForEmail.test(this.state.email);
    if (emailAdded && this.state.email !== '') {
      validEmail = true;
    } else {
      updated.emailErrorMessage = 'Add a valid email.';
    }
    /* validation of fullname */

    /* validation for teamPageUrl */
    // const enteredTeamPageUrl = regExForUrl.test(this.state.teamPageUrl);
    if (this.state.teamPageUrl !== '' && this.state.teamPageUrl !== undefined) {
      updated.validTeamPageUrl = true;
    } else {
      updated.teamPageUrlErrorMessage = 'Please insert a valid url.';
    }
    /* validation for teamPageUrl */

    /* validation for Questionnaire Link */
    // const enteredQuestionaireLink = regExForUrl.test(this.state.questionLink);
    if (this.state.questionLink === '' && this.state.questionLink !== undefined) {
      updated.validQuestionaire = true;
    } else if (this.state.questionLink === 'no page') {
      updated.questionaireErrorMessage = 'Please add a valid questionaire url';
    } else if (this.state.questionLink !== '' && this.state.questionLink !== undefined) {
      updated.validQuestionaire = true;
    } else {
      updated.questionaireErrorMessage = 'Please add a valid questionaire url';
    }
    /* validation for question lin */

    this.setState(updated, () => {
      let payload = {};
      const s = this.state;
      // eslint-disable-next-line
      const profile_pic = 'no_profile_pic';
      const { college, fullName, college_id, sport, states, city, teamPageUrl, questionLink, email,
        division, validHighSchool, validQuestionaire, validTeamPageUrl, validCity, validState } = s;

      payload = Object.assign(payload, {
        name: fullName,
        college,
        coach_email: email,
        college_id,
        sport,
        state: states,
        city,
        profile_pic,
        division,
        question_link: questionLink,
        team_page_link: teamPageUrl,
      });
      if (questionLink !== '') {
        payload['question_link'] = questionLink; // eslint-disable-line
      }
      if (validHighSchool && validQuestionaire && validTeamPageUrl && validCity && validState
        && validEmail) {
        this.props.addCoach(payload);
      }
    });
  };

  render() {
    const { cityErrorMessage, city, fullName, fullNameErrorMessage, highSchoolErrorMessage,
      stateErrorMessage, sport, state, teamPageUrlErrorMessage, teamPageUrl, email,
      emailErrorMessage, questionaireErrorMessage, questionLink } = this.state;
    const { coachAdded } = this.props;
    const renderForm = renderIf(!coachAdded);
    const renderSuccessMessage = renderIf(coachAdded);
    return (
      <div className={cn('col s12', styles.removePadding)}>
        {renderForm(
          <div className={cn('col s12 m7', styles.removePadding)}>
            <div className={cn('col s12')}>
              <Error message="All fields are mandatory." />
            </div>
            <div className={highSchoolErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
              <span>SELECT COLLEGE</span>
              <SearchCollegeComponent usedFor="contact" getDataForCoach={this.getDataForCoach} />
            </div>
            <div className={cn('col s12 m6', styles.autoComplete)}>
              <span>SPORT</span>
              <div className={styles.autoCompleteToolbox}>
                <AutocompleteToolbox
                  value={sport}
                  onChange={val => this.handleChange('sport', val)}
                  multiple={false}
                />
              </div>
            </div>
            <div className={fullNameErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
              <span>FULLNAME</span>
              <Input
                value={fullName}
                onChange={val => this.handleChange('fullName', val)}
                onFocus={() => this.removeValue('fullNameErrorMessage')}
              />
              <Error message={fullNameErrorMessage} />
            </div>
            <div className={emailErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
              <span>EMAIL</span>
              <Input
                value={email}
                onChange={val => this.handleChange('email', val)}
                onFocus={() => this.removeValue('emailErrorMessage')}
              />
              <Error message={emailErrorMessage} />
            </div>
            <div className={cn('col s12 m6', styles.autoCompleteState)}>
              <span>STATE</span>
              <div className={stateErrorMessage === '' ? styles.autoCompleteToolbox : styles.autoCompleteToolboxOnError}>
                <AutocompleteToolbox
                  onChange={val => this.handleChange('state', val)}
                  source={statesList}
                  onFocus={() => this.removeValue('stateErrorMessage')}
                  onQueryChange={val => this.handleChange('state', val)}
                  value={state}
                  multiple={false}
                />
              </div>
              <Error message={stateErrorMessage} />
            </div>
            <div className={cityErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanOnError)}>
              <span>CITY</span>
              <Input
                value={city}
                onChange={val => this.handleChange('city', val)}
                onFocus={() => this.removeValue('cityErrorMessage')}
              />
              <Error message={cityErrorMessage} />
            </div>
            <div
              className={teamPageUrlErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpanWithoutTopSpace)
                : cn('col s12 m6', styles.halfWidthWithSpanWithoutTopSpaceOnError)}
            >
              <span>TEAM PAGE URL</span>
              <Input
                value={teamPageUrl}
                onChange={val => this.handleChange('teamPageUrl', val)}
                onFocus={() => this.removeValue('teamPageUrlErrorMessage')}
              />
              <Error message={this.state.teamPageUrlErrorMessage} />
            </div>
            <div
              className={questionaireErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpanWithoutTopSpace)
                : cn('col s12 m6', styles.halfWidthWithSpanWithoutTopSpaceOnError)}
            >
              <span>QUESTIONAIRE LINK</span>
              <Input
                value={questionLink}
                onChange={val => this.handleChange('questionLink', val)}
                onFocus={() => this.removeValue('questionaireErrorMessage')}
              />
              <Error message={questionaireErrorMessage} />
            </div>
            <Button label="ADD COACH" onClick={this.handleOnclick} style={styles.buttonContainer} />
          </div>,
        )}
        {renderSuccessMessage(
          <span className={styles.successMessage}>
            Coach added. <br /> <br />
            <Button label="ADD ANOTHER COACH" onClick={this.addAnotherCoach} style={styles.buttonContainer} />
          </span>,
        )}
      </div>
    );
  }
}

export default DeleteCoach;



// WEBPACK FOOTER //
// ./src/containers/Admin/components/CoachView/components/AddCoach/View.js